import { useEffect, useState } from "react";
import { api, fmtDateTime, formatApiError } from "@/lib/api";
import { Loader2, Inbox, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdminDemoRequests() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/demo-requests").then(({ data }) => setItems(data.items)).catch((e) => { toast.error(formatApiError(e)); setItems([]); });
  }, []);
  return (
    <div data-testid="admin-demo-requests" className="max-w-5xl space-y-5">
      <div>
        <div className="flex items-center gap-2 text-xs font-mono-caps text-zinc-500"><Inbox className="h-4 w-4" /> Site de vendas</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase text-zinc-100 mt-1">Pedidos de demonstração</h1>
        <p className="text-sm text-zinc-400 mt-1">Enviados pelo formulário de autooficina.com.br.</p>
      </div>
      {!items ? <div className="py-12 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>
        : !items.length ? <p data-testid="demo-empty" className="text-sm text-zinc-500">Nenhum pedido ainda.</p> : (
        <ul data-testid="demo-list" className="divide-y divide-zinc-800 rounded-xl border border-zinc-800 bg-zinc-950/70">
          {items.map((d) => (
            <li key={d.id} data-testid={`demo-row-${d.id}`} className="p-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <div className="flex-1 min-w-0">
                <div className="font-bold text-zinc-100 truncate">{d.shop_name}</div>
                <div className="text-sm text-zinc-400 truncate">{d.name} · {d.city}</div>
              </div>
              <a href={`https://wa.me/55${d.phone.replace(/^55/, "")}`} target="_blank" rel="noopener noreferrer" data-testid={`demo-wa-${d.id}`}
                 className="inline-flex items-center gap-1 text-sm text-green-neon hover:underline"><MessageCircle className="h-4 w-4" /> {d.phone}</a>
              <div className="text-xs text-zinc-500 sm:w-40 sm:text-right">{fmtDateTime(d.created_at)}{d.email_status === "falhou" && <span className="block text-red-400">e-mail falhou</span>}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
